import { useQuery } from "@tanstack/react-query";
import { getFrontendMetadata } from "../services/api/settings";

export const useGetFrontendMetadata = () => {
  return useQuery({
    queryKey: ['getFrontendMetadata'],
    queryFn: () => getFrontendMetadata(),
  })
}
